import Footer from '../components/footer'
import Header from '../components/header/header'
import RatingWidget from '../components/rating/ratingWidget'
import DiscordWidget from '../components/discord/discordWidget'

export default function Home() {
    return (
        <>
            <Header />
            <section className="w-full flex flex-col items-center py-8">
                <h2 className="text-xl font-bold text-pride-pink mb-3">What do you think of Neko-CLI?</h2>
                <RatingWidget />
            </section>
            <section className="w-full flex flex-col items-center py-4 px-4">
                <DiscordWidget />
            </section>
            <Footer />
        </>
    )
}